import React from 'react';
import PropTypes from 'prop-types';
import ShowConditionsButtonComponent from '@Components/Results/reactions/reaction-details/show-conditions-button.component';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ShowMoreComponent from '@Components/Results/utils/show-more.component';
import ReactReactionAdditionalInfoHelper from '@Components/Results/services/react-reaction-additional-info-helper.service';
import ReactionDetailRowComponent from '@Components/Results/reactions/reaction-details/reaction-detail-row.component';
/* eslint-disable react/destructuring-assignment */
export default class ReactionDetailsTableComponent extends React.Component {
  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.isCIDatabase = ReactReactionAdditionalInfoHelper.isCIDatabase(this.props.databaseId);
    this.containerClass = this.props.isHitDetails ? 'reaction-hit-details' : 'reaction-details';
  }

  componentDidMount() {
    if (!this.props.isHitDetails && this.props.hasHitDetails) {
      this.tableRef.current.scrollTo({ top: this.tableRef.current.scrollHeight, behavior: 'smooth' });
    }
  }

  render() {
    const { metadata } = this.props;
    const allowShowMore = !metadata.isViewPreview || this.props.isHitDetails;
    const rows = this.props.details.map((detail, index) => {
      return (
        <ReactionDetailRowComponent
          metadata={metadata}
          /* eslint-disable-next-line react/no-array-index-key */
          key={index}
          detail={detail}
          index={this.props.index}
          reactionId={this.props.reactionId}
          isHit={this.props.isHitDetails || detail.isHit}
          spinnerId={this.props.spinnerId}
          databaseId={this.props.databaseId}
          largestProduct={this.props.largestProduct}
        />
      );
    });

    return (
      <table
        ref={this.tableRef}
        id={`${this.containerClass}-${this.props.index}`}
        className="rx-reactions-table rx-reactions-table--bordered rx-table--full-width rx-table--full-height display-table">
        <thead>
          <tr className="rx-reactions-table__header display-table-row">
            <th className="rx-reactions-table__conditions display-table-cell">Conditions</th>
            <th className="rx-reactions-table__yield display-table-cell">Yield</th>
            <th className="rx-reactions-table__references display-table-cell show-for-tablet">
              {this.isCIDatabase ? 'Reference/Experiment' : 'Reference'}
            </th>
          </tr>
        </thead>
        <tbody>
          {rows}
          {this.props.displayFooter && this.props.initialDetailsNumber < this.props.detailsCount && (
            <tr className="display-table-row">
              <td className="display-table-cell" colSpan="4">
                <div className="rx-table__caption rx-btn-group--center">
                  {allowShowMore && (
                    <ShowMoreComponent
                      labelAll={`Show all ${this.props.isHitDetails ? 'hits' : 'conditions'}`}
                      initial={this.props.initialDetailsNumber}
                      current={this.props.details.length}
                      total={this.props.detailsCount}
                      container={`#${this.containerClass}-${this.props.index}`}
                      scrollToLess={`#${this.containerClass}-${this.props.index}`}
                      moreHandler={this.props.showMoreHandler}
                      lessHandler={this.props.showLessHandler}
                    />
                  )}
                  {allowShowMore && this.props.showNextConditions && (
                    <ShowConditionsButtonComponent
                      toggleAllDetails={this.props.toggleAllDetails}
                      showNextConditions={this.props.showNextConditions}
                      index={this.props.index}
                    />
                  )}
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }
}

ReactionDetailsTableComponent.defaultProps = {
  displayFooter: true,
};

ReactionDetailsTableComponent.propTypes = {
  metadata: MetadataPropTypesShape,
  reactionId: PropTypes.string.isRequired,
  details: PropTypes.array.isRequired,
  detailsCount: PropTypes.number.isRequired,
  initialDetailsNumber: PropTypes.number,
  isHitDetails: PropTypes.bool,
  hasHitDetails: PropTypes.bool,
  spinnerId: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
  showMoreHandler: PropTypes.func.isRequired,
  showLessHandler: PropTypes.func.isRequired,
  showNextConditions: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  toggleAllDetails: PropTypes.func,
  databaseId: PropTypes.string.isRequired,
  displayFooter: PropTypes.bool,
  largestProduct: PropTypes.string,
};
